import { createRouter, createWebHashHistory } from 'vue-router'
import { routes } from './routes'

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_BASE_URL || ''),
  routes: routes,
})

export default router
